import { Props } from 'docz';
import { Playground } from '@playground';
import { Text, H1, H2, H3, H4, H5, H6, P, Span, B, Hr } from "../../../../../packages/core/src/components/typography/typography";
import * as React from 'react';
export default {
  Props,
  Playground,
  Text,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  P,
  Span,
  B,
  Hr,
  React
};